import React from 'react';

import Container from './Container.jsx';
import Kit from '../utility/Kit.jsx';
import Token from '../utility/Token.jsx';
import { default as _TypeConfig } from './TypeConfig.jsx';
import Utilities from '../utility/Utilities.jsx';

// #region LABEL VALUE

function LabelValue(props) {
    let blockProps = {};
    let styleLabel = props.styleLabel;
    let styleValue = props.styleValue;
    let descriptionProps, labelProps, valueProps;
    if (props.config && props.config.config) {
        blockProps = props.config.config.Block || {};
        descriptionProps = props.config.config.Description;
        labelProps = props.config.config.Label;
        valueProps = props.config.config.Value;
    }
    let value;
    if (props.value != undefined) {
        value = props.value;
    } else if (!props.builder && props.allowEmptyValue != true) {
        return null;
    }
    let placeholder;
    if (props.builder) {
        placeholder = (
            <React.Fragment>
                {
                    props.renderPlaceholder &&
                    Utilities.Builder.emptyBlockPlaceholder()
                }
                {Utilities.Builder.dragOutline()}
            </React.Fragment>
        );
    }
    let description, label;
    if (blockProps.count != '1') {
        label = props.label || blockProps.textLabel;
        if (blockProps.count != '2') {
            description = props.descriptionContent || props.description;
        }
    }
    if (descriptionProps && description) {
        description = Kit.updateDesign(description, props.kit);
    }
    if (labelProps && label) {
        label = Kit.updateDesign(label, props.kit)
        if (!styleLabel) {
            styleLabel = {};
        }
        styleLabel.whiteSpace = 'pre-wrap';
    }
    if (valueProps && value) {
        value = Kit.updateDesign(value, props.kit)
        if (!styleValue) {
            styleValue = {};
        }
        styleValue.whiteSpace = 'pre-wrap';
    }
    const style = Utilities.Config.getStyle(blockProps, undefined, (propName, propValue, _style) => {
        if (propName.indexOf('Border') < 0) {
            return;
        }
        if (propValue && propValue.value && propValue.unit) {
            _style[propName.replace('Border', '')] = `${propValue.value}${propValue.unit}`;
        }
        return true;
    });
    const cellStyle = props.rowStyle || {};
    let content;
    switch (blockProps.displayType) {
        case 'rows': {
            let styleLabelCell = { whiteSpace: labelProps == undefined ? 'pre-wrap' : undefined };
            let styleDescriptionCell;
            if (description) {
                styleDescriptionCell = { ...cellStyle };
                if (descriptionProps && descriptionProps.paddingBottom && !Utilities.isNullOrWhitespace(descriptionProps.paddingBottom.value)) {
                    styleDescriptionCell.paddingBottom = `${descriptionProps.paddingBottom.value}${descriptionProps.paddingBottom.unit}`;
                }
            } else {
                styleLabelCell = { ...styleLabelCell, ...cellStyle };
            }
            if (labelProps && labelProps.paddingBottom && !Utilities.isNullOrWhitespace(labelProps.paddingBottom.value)) {
                styleLabelCell.paddingBottom = `${labelProps.paddingBottom.value}${labelProps.paddingBottom.unit}`;
            }
            const styleValueCell = { whiteSpace: valueProps == undefined ? 'pre-wrap' : undefined };
            content = (
                <React.Fragment>
                    {
                        description != undefined &&
                        <tr>
                            <td style={styleDescriptionCell}>
                                {
                                    descriptionProps != undefined &&
                                    <div dangerouslySetInnerHTML={{ __html: description }} />
                                }
                            </td>
                        </tr>
                    }
                    {
                        value != undefined &&
                        label != undefined &&
                        <tr>
                            <td style={styleLabelCell}>
                                {
                                    labelProps != undefined &&
                                    <div style={styleLabel} dangerouslySetInnerHTML={{ __html: label }} />
                                }
                                {
                                    labelProps == undefined &&
                                    <span style={styleLabel}>{label}</span>
                                }
                            </td>
                        </tr>
                    }
                    <tr>
                        <td style={styleValueCell}>
                            {
                                valueProps != undefined &&
                                <div style={styleValue} dangerouslySetInnerHTML={{ __html: value }} />
                            }
                            {
                                valueProps == undefined &&
                                <span style={styleValue}>{value}</span>
                            }
                            {placeholder}
                        </td>
                    </tr>
                </React.Fragment>
            );
            break;
        }
        case 'columns':
        default:
            let styleDescriptionCell;
            if (description) {
                styleDescriptionCell = { ...cellStyle };
                if (descriptionProps) {
                    if (descriptionProps.width && !Utilities.isNullOrWhitespace(descriptionProps.width.value)) {
                        if (parseInt(descriptionProps.width.value, 10) == 0) {
                            styleDescriptionCell.display = 'none';
                        }
                        styleDescriptionCell.width = `${descriptionProps.width.value}${descriptionProps.width.unit}`;
                    }
                    if (descriptionProps.paddingRight && !Utilities.isNullOrWhitespace(descriptionProps.paddingRight.value)) {
                        styleDescriptionCell.paddingRight = `${descriptionProps.paddingRight.value}${descriptionProps.paddingRight.unit}`;
                    }
                }
            }
            let styleLabelCell = { ...cellStyle };
            if (labelProps) {
                if (labelProps.width && !Utilities.isNullOrWhitespace(labelProps.width.value)) {
                    if (parseInt(labelProps.width.value, 10) == 0) {
                        styleLabelCell.display = 'none';
                    }
                    styleLabelCell.width = `${labelProps.width.value}${labelProps.width.unit}`;
                }
                if (labelProps.paddingRight && !Utilities.isNullOrWhitespace(labelProps.paddingRight.value)) {
                    styleLabelCell.paddingRight = `${labelProps.paddingRight.value}${labelProps.paddingRight.unit}`;
                }
            }
            if (props.collapseLabelIfEmpty == true && Utilities.isHTMLContentEmpty(label)) {
                styleLabelCell.display = 'none';
                styleLabelCell.width = '0';
            }
            let styleValueCell = { minWidth: '10%', ...cellStyle };
            if (valueProps) {
                if (valueProps.width && !Utilities.isNullOrWhitespace(valueProps.width.value)) {
                    if (parseInt(valueProps.width.value, 10) == 0) {
                        styleValueCell.display = 'none';
                    }
                    styleValueCell.width = `${valueProps.width.value}${valueProps.width.unit}`;
                }
            }
            if (props.collapseValueIfEmpty == true && Utilities.isHTMLContentEmpty(value)) {
                styleValueCell.display = 'none';
                styleValueCell.width = '0';
            }
            // if (labelProps && !styleLabelCell.width && !styleValueCell.width) {
            //     styleLabelCell.width = '50%';
            // }
            content = (
                <tr>
                    {
                        description != undefined &&
                        <td style={styleDescriptionCell}>
                            {
                                descriptionProps != undefined &&
                                <div dangerouslySetInnerHTML={{ __html: description }} />
                            }
                        </td>
                    }
                    {
                        value != undefined &&
                        label != undefined &&
                        <td style={styleLabelCell}>
                            {
                                labelProps != undefined &&
                                <div style={styleLabel} dangerouslySetInnerHTML={{ __html: label }} />
                            }
                            {
                                labelProps == undefined &&
                                <span style={styleLabel}>{label}</span>
                            }
                        </td>
                    }
                    <td style={styleValueCell}>
                        {
                            valueProps != undefined &&
                            <div style={styleValue} dangerouslySetInnerHTML={{ __html: value }} />
                        }
                        {
                            valueProps == undefined &&
                            <span style={styleValue}>{value}</span>
                        }
                        {placeholder}
                    </td>
                </tr>
            );
            break;
    }
    if (props.container == false) {
        return content;
    }
    content = (
        <tr>
            <td>
                <table
                    border="0"
                    cellPadding={props.cellPadding || "0"}
                    cellSpacing={props.cellSpacing || "0"}
                    style={style}
                    width="100%">
                    <tbody>
                        {content}
                    </tbody>
                </table>
            </td>
        </tr>
    )
    return (
        <Container
            builder={props.builder}
            className={props.className}
            config={props.config}
            dataType={props.dataType}
            onClick={props.onClick}
            onDragEnter={props.onDragEnter}
            onDragStart={props.onDragStart}>
            {content}
        </Container>
    );
}

const LabelValueTypeConfig = {
    options: {
        _columns: (name) => {
            return [
                {
                    display: 'Column Width',
                    name: `columnWidth${name}`,
                    type: 'text',
                    visible: (config) => config.Block && config.Block.displayType != 'columns'
                },
                {
                    type: 'spacer',
                    visible: (config) => config.Block && config.Block.displayType != 'columns'
                },
                {
                    display: 'Vertical Alignment',
                    name: `verticalAlign${name}`,
                    options: [
                        { display: 'Top', value: 'top' },
                        { display: 'Middle', value: 'middle' },
                        { display: 'Bottom', value: 'bottom' }
                    ],
                    type: 'dropdown',
                    value: 'top',
                    visible: (config) => config.Block && config.Block.displayType != 'columns'
                },
                {
                    display: 'Text Alignment',
                    name: `textAlign${name}`,
                    options: [
                        { display: 'Left', value: 'left' },
                        { display: 'Center', value: 'center' },
                        { display: 'Right', value: 'right' }
                    ],
                    type: 'dropdown',
                    value: 'left',
                    visible: (config) => config.Block && config.Block.displayType != 'columns'
                },
                {
                    display: 'Padding Left',
                    name: `paddingLeft${name}`,
                    type: 'text',
                    visible: (config) => config.Block && config.Block.displayType != 'columns'
                },
                {
                    display: 'Padding Right',
                    name: `paddingRight${name}`,
                    type: 'text',
                    visible: (config) => config.Block && config.Block.displayType != 'columns'
                }
            ]
        },
        displayType: (props) => {
            const _props = props || {};
            const option = {
                display: 'Display Type',
                name: 'displayType',
                options: [
                    { display: 'Columns', value: 'columns' },
                    { display: 'Inline', value: 'inline' }
                ],
                type: 'dropdown',
                value: _props.value || 'columns'
            };
            if (_props.includeRows != false) {
                option.options.splice(1, 0, { display: 'Rows', value: 'rows' });
            }
            return option;
        },
        label: (props, label, fontStyle, textTransform) => {
            const _props = props || {};
            if (!_props.name) {
                _props.name = 'Label';
            }
            let labelOptions = [];
            if (label) {
                labelOptions = [
                    {
                        display: 'Label Display Text',
                        name: `text${_props.name}`,
                        type: 'text',
                        ...label
                    },
                    { type: 'spacer' }
                ];
            }
            let options = _TypeConfig.options.text(_props, fontStyle, textTransform);
            const optionCount = options.length;
            options = labelOptions.concat(options);
            options.push({
                display: 'Margin Right',
                name: `marginRight${_props.name}`,
                type: 'text',
                visible: (config) => config.Block && config.Block.displayType == 'inline'
            });
            options.push({
                display: 'Line Spacing',
                name: `marginBottom${_props.name}`,
                type: 'text',
                visible: (config) => config.Block && config.Block.displayType == 'rows'
            });
            const columnSpacer = {
                type: 'spacer',
                visible: (config) => config.Block && config.Block.displayType != 'columns'
            };
            if (optionCount % 2 != 0) {
                options.push(columnSpacer);
            } else {
                options.push({
                    type: 'spacer',
                    visible: (config) => config.Block && config.Block.displayType != 'columns'
                });
            }
            options.push(columnSpacer);
            options.push(columnSpacer);
            return [
                ...options,
                ...TypeConfig.labelValue.options._columns(_props.name)
            ]
        },
        value: (props, fontStyle, textTransform, lineSpacing) => {
            const _props = props || {};
            _props.name = 'Value';
            let options = _TypeConfig.options.text(_props, fontStyle, textTransform, lineSpacing);
            const columnSpacer = {
                type: 'spacer',
                visible: (config) => config.Block && config.Block.displayType != 'columns'
            };
            options.push(columnSpacer);
            options.push(columnSpacer);
            if (options.length % 2 != 0) {
                options.push(columnSpacer);
            }
            options = options.concat(TypeConfig.labelValue.options._columns(_props.name));
            return options;
        }
    },
    panel: {
        block: (defaultCount, options = []) => {
            const group = 'block';
            return {
                group,
                label: 'Design',
                options: [
                    {
                        display: 'Display Type',
                        group,
                        name: 'displayType',
                        options: [
                            { display: 'Columns', value: 'columns' },
                            { display: 'Rows', value: 'rows' }
                        ],
                        type: 'dropdown',
                        value: 'columns'
                    },
                    {
                        display: 'Column Count',
                        group,
                        name: 'count',
                        options: [
                            { display: '1', value: '1' },
                            { display: '2', value: '2' },
                            { display: '3', value: '3' }
                        ],
                        type: 'dropdown',
                        value: defaultCount || '2',
                        visible: (config) => config.Block && config.Block.displayType == 'columns'
                    },
                    {
                        display: 'Row Count',
                        group,
                        name: 'count',
                        options: [
                            { display: '1', value: '1' },
                            { display: '2', value: '2' },
                            { display: '3', value: '3' }
                        ],
                        type: 'dropdown',
                        value: defaultCount || '2',
                        visible: (config) => config.Block && config.Block.displayType == 'rows'
                    },
                    ...options,
                    {
                        fullWidth: true,
                        group,
                        type: 'spacer-short'
                    },
                    {
                        display: 'Border Properties',
                        group,
                        id: 'borderProps',
                        type: 'header'
                    },
                    {
                        display: 'Border',
                        group,
                        name: 'border',
                        options: _TypeConfig.dropdown.measurement(),
                        type: 'border'
                    },
                    {
                        disabled: ['marginBottom', 'marginLeft', 'marginRight', 'marginTop'],
                        display: 'Border Spacing',
                        group,
                        name: 'paddingMarginBorder',
                        nameSuffix: 'Border',
                        options: _TypeConfig.dropdown.measurement(),
                        type: 'paddingMargin'
                    }
                ]
            };
        },
        description: (defaultDesign) => {
            const group = 'description';
            return {
                group,
                options: [
                    {
                        display: 'Column 1',
                        group,
                        id: 'col1Props',
                        type: 'tab',
                        visible: (config) => config.Block && config.Block.displayType == 'columns' && config.Block.count == '3'
                    },
                    {
                        display: 'Row 1',
                        group,
                        id: 'row1Props',
                        type: 'tab',
                        visible: (config) => config.Block && config.Block.displayType == 'rows' && config.Block.count == '3'
                    },
                    {
                        display: 'Design',
                        fullWidth: true,
                        group,
                        name: 'design',
                        type: 'rich-text-collateral-short',
                        value: defaultDesign
                    },
                    {
                        display: 'Column Width',
                        fullWidth: true,
                        group,
                        name: 'width',
                        options: _TypeConfig.dropdown.measurement(true),
                        type: 'measurement-slider',
                        visible: (config) => config.Block && config.Block.displayType == 'columns'
                    },
                    {
                        display: 'Column Spacing',
                        fullWidth: true,
                        group,
                        max: '100',
                        name: 'paddingRight',
                        options: _TypeConfig.dropdown.measurement(),
                        type: 'measurement-slider',
                        visible: (config) => config.Block && config.Block.displayType == 'columns'
                    },
                    {
                        display: 'Line Spacing',
                        fullWidth: true,
                        group,
                        max: '100',
                        name: 'paddingBottom',
                        options: _TypeConfig.dropdown.measurement(),
                        type: 'measurement-slider',
                        visible: (config) => config.Block && config.Block.displayType == 'rows'
                    }
                ]
            }
        },
        label: (defaultDesign) => {
            const group = 'label';
            return {
                group,
                options: [
                    {
                        display: 'Column 1',
                        group,
                        id: 'col1Props',
                        type: 'tab',
                        visible: (config) => config.Block && config.Block.displayType == 'columns' && config.Block.count == '2'
                    },
                    {
                        display: 'Column 2',
                        group,
                        id: 'col2Props',
                        type: 'tab',
                        visible: (config) => config.Block && config.Block.displayType == 'columns' && config.Block.count == '3'
                    },
                    {
                        display: 'Row 1',
                        group,
                        id: 'row1Props',
                        type: 'tab',
                        visible: (config) => config.Block && config.Block.displayType == 'rows' && config.Block.count == '2'
                    },
                    {
                        display: 'Row 2',
                        group,
                        id: 'row2Props',
                        type: 'tab',
                        visible: (config) => config.Block && config.Block.displayType == 'rows' && config.Block.count == '3'
                    },
                    {
                        display: 'Design',
                        fullWidth: true,
                        group,
                        name: 'design',
                        type: 'rich-text-collateral-short',
                        value: defaultDesign
                    },
                    {
                        display: 'Column Width',
                        fullWidth: true,
                        group,
                        name: 'width',
                        options: _TypeConfig.dropdown.measurement(true),
                        type: 'measurement-slider',
                        visible: (config) => config.Block && config.Block.displayType == 'columns'
                    },
                    {
                        display: 'Column Spacing',
                        fullWidth: true,
                        group,
                        max: '100',
                        name: 'paddingRight',
                        options: _TypeConfig.dropdown.measurement(),
                        type: 'measurement-slider',
                        visible: (config) => config.Block && config.Block.displayType == 'columns'
                    },
                    {
                        display: 'Line Spacing',
                        fullWidth: true,
                        group,
                        max: '100',
                        name: 'paddingBottom',
                        options: _TypeConfig.dropdown.measurement(),
                        type: 'measurement-slider',
                        visible: (config) => config.Block && config.Block.displayType == 'rows'
                    }
                ]
            }
        },
        style: () => _TypeConfig.panel.layoutStyle('block'),
        value: (defaultDesign) => {
            const group = 'value';
            return {
                group,
                options: [
                    {
                        display: 'Content',
                        group,
                        id: 'contentProps',
                        type: 'tab',
                        visible: (config) => config.Block && config.Block.count == '1'
                    },
                    {
                        display: 'Column 2',
                        group,
                        id: 'col2Props',
                        type: 'tab',
                        visible: (config) => config.Block && config.Block.displayType == 'columns' && config.Block.count == '2'
                    },
                    {
                        display: 'Column 3',
                        group,
                        id: 'col3Props',
                        type: 'tab',
                        visible: (config) => config.Block && config.Block.displayType == 'columns' && config.Block.count == '3'
                    },
                    {
                        display: 'Row 2',
                        group,
                        id: 'row2Props',
                        type: 'tab',
                        visible: (config) => config.Block && config.Block.displayType == 'rows' && config.Block.count == '2'
                    },
                    {
                        display: 'Row 3',
                        group,
                        id: 'row3Props',
                        type: 'tab',
                        visible: (config) => config.Block && config.Block.displayType == 'rows' && config.Block.count == '3'
                    },
                    {
                        display: 'Design',
                        fullWidth: true,
                        group,
                        name: 'design',
                        type: 'rich-text-collateral-short',
                        value: defaultDesign || Utilities.wrapTextForEditor({ text: 'Value' })
                    },
                    {
                        display: 'Column Width',
                        fullWidth: true,
                        group,
                        name: 'width',
                        options: _TypeConfig.dropdown.measurement(true),
                        type: 'measurement-slider',
                        visible: (config) => config.Block && config.Block.displayType == 'columns' && config.Block.count != '1'
                    }
                ]
            }
        }
    }
};

// #endregion LABEL VALUE

// #region VALUE

function Value(props) {
    let content;
    let style = props.style || {};
    if (props.config && props.config.config && props.config.config.Block) {
        style = { ...style, ...Utilities.Config.getStyle(props.config.config.Block, { display: 'inline-block', width: '100%' }) };
        if (props.value && props.value.length > 0) {
            content = <div dangerouslySetInnerHTML={{ __html: Kit.updateDesign(props.value, props.kit) }} style={style} />
        }
    }
    if (!props.builder && !content) {
        return null;
    }
    return (
        <Container
            builder={props.builder}
            className={props.className}
            config={props.config}
            dataType={props.dataType}
            onClick={props.onClick}
            onDragEnter={props.onDragEnter}
            onDragStart={props.onDragStart}>
            <tr>
                <td>
                    {content}
                    {
                        props.builder &&
                        <React.Fragment>
                            {
                                !content &&
                                Utilities.Builder.emptyBlockPlaceholder()
                            }
                            {Utilities.Builder.dragOutline()}
                        </React.Fragment>
                    }
                </td>
            </tr>
        </Container>
    );
}

const ValueTypeConfig = {
    panel: {
        style: (group) => _TypeConfig.panel.layoutStyle(group, 'Layout', {})
    }
};

// #endregion VALUE

function withLabelTokenParsing(WrappedComponent, tokenHandler, options = {}) {
    return Token.withContentTokenParsing(
        function (props) {
            const [labelContent, setLabelContent] = React.useState(undefined);
            React.useEffect(() => {
                if (!props.id) {
                    return;
                }
                setLabelContent(props.onParseContent(props, props.config.config.Label.design));
            }, [props.id, props.config.config.Label.design, props.visibilityHash]);

            if (!props.config.config.Description) {
                props.config.config.Description = {};
            }
            if (props.config.config.Block && !props.config.config.Block.count) {
                props.config.config.Block.count = '2';
            }
            const [descriptionContent, setDescriptionContent] = React.useState(undefined);
            React.useEffect(() => {
                if (!props.id) {
                    return;
                }
                setDescriptionContent(props.onParseContent(props, props.config.config.Description.design));
            }, [props.id, props.config.config.Description.design, props.visibilityHash]);

            if (props.serverSide) {
                if (labelContent == undefined) {
                    setLabelContent(props.onParseContent(props, props.config.config.Label.design));
                }
                if (descriptionContent == undefined) {
                    setDescriptionContent(props.onParseContent(props, props.config.config.Description.design));
                }
            }
            return <WrappedComponent {...props} descriptionContent={descriptionContent} label={labelContent}>{props.children}</WrappedComponent>
        },
        {
            contentTokenSourceHandler: (props) => props.config && props.config.config && props.config.config.Value && props.config.config.Value.design,
            extraParseConditionHandler: (props) => {
                const parseConditions = [];
                if (props.config && props.config.config && props.config.config.Value) {
                    parseConditions.push(props.config.config.Value.design);
                }
                return parseConditions;
            },
            ...options
        },
        tokenHandler
    )
}

export {
    LabelValue,
    LabelValueTypeConfig,
    Value,
    ValueTypeConfig,
    withLabelTokenParsing
}